<template>
<div class="flow-main" v-loading="loading">
  <div class="flow-view-lf-top">
    <el-button-group>
      <el-button type="primary" icon="el-icon-s-marketing" round :disabled="true" title="流程图">流程图</el-button>
      <el-button type="primary" icon="el-icon-printer" round @click="print" title="打印" >打印</el-button>
      <el-button type="primary" icon="el-icon-printer" round :disabled="true" title="导出" >导出</el-button>
      <el-button type="primary" icon="el-icon-tickets" round :disabled="true" title="审批明细">审批明细</el-button>
      <el-button type="primary" icon="el-icon-close" round title="返回" @click="navBack">返回</el-button>
    </el-button-group>
  </div>
  <div id="old-flow-main">
    <div v-if="showData.task" class="flow-main-header">
      {{showData.task.ProcessName}}
    </div>
    <el-descriptions v-if="showData.task" class="margin-top" direction="vertical" :column="1" size="mini" border>
      <el-descriptions-item label="审批表单" v-if="showData.master_table&&showData.master_table_obj[showData.master_table]">
        <el-descriptions class="margin-top" :column="3" size="mini" border :label-style="{width: '100px'}">
          <template v-for="(col,index) in showData.master_table_obj[showData.master_table]">
            <el-descriptions-item :key="index" :label="col">
              <div class="flow-main-item">
                {{showData.master_table_data[col]}}
              </div>
            </el-descriptions-item>
          </template>

        </el-descriptions>
      </el-descriptions-item>

      <el-descriptions-item label="子表单">

        <el-descriptions class="margin-top" :column="1" size="mini" direction="vertical" border >
          <template v-for="(sub_table,index) in showData.sub_table_list">
            <el-descriptions-item :label="sub_table" :key="index">
              <el-table
                :data="showData.sub_table_data[sub_table]"
                border style="width: 100%;">
                <el-table-column
                  v-for="(sub_col,sub_index) in showData.sub_table_obj[sub_table]"
                  :key="sub_index"
                  :prop="sub_col"
                  :label="sub_col"
                  min-width="100"
                ></el-table-column>
              </el-table>
            </el-descriptions-item>
          </template>

        </el-descriptions>
      </el-descriptions-item>

      <el-descriptions-item label="审批明细">
        <el-descriptions class="margin-top" :column="1" size="mini" border :label-style="{width: '100px'}">
          <el-descriptions-item v-for="(item,index) in showData.steps_list" :key="index" :label="item.NodeName">
            <div style="margin: 5px 5px">
              <span style="font-weight: bold;margin: 5px 0;font-size: 14px;">{{item.HandlerAccount}}</span>

              <span style="margin: 5px 5px">
            {{item.FinishAt?item.FinishAt:item.ReceiveAt}}
          </span>
            </div>
            <div style="margin: 5px 5px">
              <el-tag>{{item.SelAction}}</el-tag> {{item.Comments}}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>

      <el-descriptions-item label="附件">
        <el-table
          size="mini"
          :data="showData.attachment_list"
          border
          :cell-style="{padding:0}">
          <el-table-column
            prop="Name"
            label="文件名">
            <template slot-scope="scope">
              <el-link type="primary" @click="taskView(scope.row,1)">{{scope.row.Name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="OwnerAccount"
            label="上传人/时间" width="200">
            <template slot-scope="scope">
              {{scope.row.OwnerAccount}} / {{scope.row.LastUpdate}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-download" @click="taskView(scope.row,1)">预览</el-button>
              <el-button type="primary" size="mini" icon="el-icon-download" @click="taskView(scope.row,2)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
  </div>

  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import Http from "./common/Http";
import ViewFile from "../Common/ViewFile";
import PrintOne from "../../../assets/lib/PrintOne";
export default {
  name: "FlowOldHistoryShow",
  components: {ViewFile},
  data(){
    return{
      loading:false,
      task_id:0,
      tableData:[],
      showData:{}
    }
  },
  activated() {
    this.task_id=this.$route.query.task_id;
    this.getData();
  },
  methods:{
    getData(){
      const that=this;
      that.dialogVisible=true;
      that.loading=true;
      Http.get("flow/FlowOldHistory/showInfo",{
        task_id:that.task_id,
      },res=>{
        if(res.code) {
          that.showData=res.data
        }
        that.loading=false;
      })
    },
    taskView(item=null,type=1) {
      const that=this;
      console.log(item);
      if(item) {
        let file_url=""
        if (item.base_url) {
          file_url=item.base_url+ item.URL
        }else {
          file_url=this.host_url+item.URL
        }
        let login_name = localStorage.getItem('login')
        let token = localStorage.getItem('token')
        if(type===1){
          that.$refs.ViewFile.show({
            width: '90vw',
            height:'80vh',
            title:item.Name,
            src:item.URL,
            bucket:'gdza',
            duration_time:86400*3,
            download(){
              // TODO 下载文件逻辑
              // window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
              __OSS__.setBucket('gdza').setKey(item.URL).download()
            }
          })
        }else {
          __OSS__.setBucket('gdza').setKey(item.URL).download()
        }
      }
    },
    navBack(){
      ERP.navigateBack()
    },
    print() {
      const that=this;
      PrintOne("#old-flow-main").extend({
        onStart: function () {
          console.log("开始打印")
        },
        onEnd: function () {
          console.log("打印完成")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flow-main{
  padding: 10px;
  min-height: 70vh;
  .flow-view-lf-top{
    background: #fff;
    padding: 10px;
    border-right: 1px solid #e5e5e5;
  }
  .flow-main-item{
    width: 20vw;
  }
  .flow-main-header{
    padding: 10px 0 20px 0;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowOldHistoryShow.vue